import { render, staticRenderFns } from "./selectfiles.vue?vue&type=template&id=18577d22&scoped=true&"
import script from "./selectfiles.vue?vue&type=script&lang=js&"
export * from "./selectfiles.vue?vue&type=script&lang=js&"
import style0 from "./selectfiles.vue?vue&type=style&index=0&id=18577d22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18577d22",
  null
  
)

export default component.exports